@if (!responsive.isMobileSignal()) {
  <app-img-header
    title="Cotizador de Distribuidores"
    hasSubTitle="true"
    [subTitle]="quotePageSubtitle"
    alt="Daimler Truck"
    image="/assets/images/cotizador/intro.jpg"
  >
  </app-img-header>
} @else {
  <app-img-header-mobile
    title="Cotizador de Distribuidores"
    hasSubTitle="true"
    [subTitle]="quotePageSubtitle"
    alt="Daimler Truck"
    image="/assets/images/cotizador/intro.jpg"
  >
  </app-img-header-mobile>
}
@if (isLoading()) {
  <app-preloader></app-preloader>
}
<app-notifications></app-notifications>
<main class="main" id="standardQuotation">
  <div id="detail">
    <div class="pageWidth">
      <form [formGroup]="form" (ngSubmit)="update()">
        @if (editOff === true) {
          @if (!responsive.isMobileSignal()) {
            <app-financial-service-view-desktop />
            <app-customer-view-desktop />
            <app-models-view-desktop />
          } @else {
            <app-financial-service-view-mobile />
            <app-customer-view-mobile />
            <app-models-view-mobile />
          }
        } @else if (customerOnlyEditMode) {
          @if (!responsive.isMobileSignal()) {
            <app-financial-service-view-desktop />
            <app-client-desktop
              #clientDesktop
              formControlName="customer"
              [creationUser]="creationUser"
              [forceReadOnly]="linkedToCreditRequest || editOff"
              [hasDeals]="deals.length > 0"
              (requestOpenModal)="openRequestedModal()"
              [customerIdSaved]="formCustomerId"
              (selectedCustomerId)="setCustomerId($event)"
              (clearDeals)="confirmCompanyChangeClearDealsLocally()"
            ></app-client-desktop>
            <app-models-view-desktop />
          } @else {
            <app-financial-service-view-mobile />
            <app-client-mobile
              #clientMobile
              formControlName="customer"
              [creationUser]="creationUser"
              [forceReadOnly]="linkedToCreditRequest || editOff"
              [hasDeals]="deals.length > 0"
              (requestOpenModal)="openRequestedModal()"
              [customerIdSaved]="formCustomerId"
              (selectedCustomerId)="setCustomerId($event)"
              (clearDeals)="confirmCompanyChangeClearDealsLocally()"
            ></app-client-mobile>
            <app-models-view-mobile />
          }
        } @else {
          <div [id]="financialComponentId">
            <h3>Servicio financiero</h3>
            <!-- Incluir clase "simple", "conSucursal" o "conDistribuidor" en el div.wrapper según corresponda -->
            @if (responsive.isMobileSignal()) {
              <!-- Mobile version -->
              <div class="wrapper">
                <div class="companiaYNumero">
                  <div class="controlWrapper">
                    <label for=""
                      >Compañia <span class="required">*</span></label
                    >
                    <div class="customSelect">
                      <select
                        type="text"
                        formControlName="companyName"
                        (change)="onInputFocus()"
                      >
                        <option [value]="'SOFOM'">SOFOM</option>
                        <option [value]="'DTFS'">DTFS</option>
                      </select>
                    </div>
                  </div>
                  <div class="controlWrapper" *ngIf="idQuote">
                    <label for="">Número</label>
                    <input type="number" [value]="idQuote" disabled />
                  </div>
                </div>

                <div class="wrapper conDistribuidor">
                  <!-- Mostrar solo si el usuario puede seleccionar Distribuidor -->
                  @if (user === "INTERNAL" && dealers.length > 1) {
                    <div class="controlWrapper">
                      <label for=""
                        >Distribuidor <span class="required">*</span></label
                      >
                      <div class="customSelect">
                        <select
                          formControlName="dealerId"
                          [disabled]="true"
                          (ngModelChange)="onChangeDealer()"
                        >
                          <option
                            *ngFor="let dealer of dealers"
                            [ngValue]="dealer.id"
                          >
                            {{ dealer.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  } @else {
                    <div id="financialService" class="controlWrapper">
                      <div class="conDistribuidorId">
                        <div>
                          <label>Distribuidor</label
                          ><span class="value">
                            <app-label-dealer
                              [dealerId]="dealerId"
                            ></app-label-dealer
                          ></span>
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Mostrar solo si el usuario puede seleccionar Sucursal -->
                  @if (
                    dealerBranches.length > 0 &&
                    !(
                      user === "DEALER" &&
                      authService.currentRoles.includes("ROLE_SELLER")
                    ) &&
                    !(
                      user === "DEALER" &&
                      authService.currentRoles.includes("ROLE_FINANCIAL")
                    )
                  ) {
                    <div
                      class="controlWrapper"
                      *ngIf="dealerBranches.length >= 1"
                    >
                      <label for=""
                        >Sucursal <span class="required">*</span></label
                      >
                      <div class="customSelect">
                        <select formControlName="wholeSaleId">
                          @if (dealerBranches.length === 0) {
                            <option [ngValue]="null">
                              {{
                                "El distribuidor no tiene sucursales habilitadas."
                              }}
                            </option>
                          } @else {
                            <option
                              *ngFor="let dealerBranch of dealerBranches"
                              [ngValue]="dealerBranch.id"
                            >
                              {{ dealerBranch.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  } @else if (dealerBranches.length === 0) {
                    <div class="controlWrapper">
                      <label>Sucursal</label>
                      <div class="customSelect">
                        <select [disabled]="true">
                          <option [ngValue]="null">
                            El distribuidor no tiene sucursales habilitadas.
                          </option>
                        </select>
                      </div>
                    </div>
                  } @else {
                    <div id="financialService" class="controlWrapper">
                      <div class="conDistribuidorId">
                        <!-- Mostrar solo si se seleccionó Sucursal-->
                        <div>
                          <label>Sucursal</label
                          ><span class="value">
                            {{
                              dealerBranchName
                                ? dealerBranchName
                                : "No se encuentra sucursal"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  }

                  <div class="controlWrapper">
                    <label for=""
                      >Nombre de la cotización
                      <span class="required">*</span></label
                    >
                    <input name="" id="quoteName" formControlName="quoteName" />
                  </div>
                </div>
              </div>
            } @else {
              <!-- Desktop version -->
              <div class="wrapper conDistribuidor">
                <div class="controlWrapper">
                  <label for="">Compañia <span class="required">*</span></label>
                  <div class="customSelect">
                    <select
                      type="text"
                      formControlName="companyName"
                      (change)="onInputFocus()"
                    >
                      <option [value]="'SOFOM'">SOFOM</option>
                      <option [value]="'DTFS'">DTFS</option>
                    </select>
                  </div>
                </div>

                <!-- Mostrar solo si el usuario puede seleccionar Distribuidor -->
                @if (user === "INTERNAL" && dealers.length > 1) {
                  <!-- Mostrar solo si el usuario puede seleccionar Distribuidor -->
                  <div class="controlWrapper">
                    <label for=""
                      >Distribuidor <span class="required">*</span></label
                    >
                    <div class="customSelect">
                      <select
                        formControlName="dealerId"
                        [disabled]="true"
                        (ngModelChange)="onChangeDealer()"
                      >
                        <option
                          *ngFor="let dealer of dealers"
                          [ngValue]="dealer.id"
                        >
                          {{ dealer.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                } @else {
                  <div id="financialService" class="controlWrapper">
                    <div class="conDistribuidorId">
                      <div>
                        <label>Distribuidor</label
                        ><span class="value">
                          <app-label-dealer
                            [dealerId]="dealerId"
                          ></app-label-dealer
                        ></span>
                      </div>
                    </div>
                  </div>
                }
                @if (
                  dealerBranches.length > 0 &&
                  !(
                    user === "DEALER" &&
                    authService.currentRoles.includes("ROLE_SELLER")
                  ) &&
                  !(
                    user === "DEALER" &&
                    authService.currentRoles.includes("ROLE_FINANCIAL")
                  )
                ) {
                  <!-- Mostrar solo si el usuario puede seleccionar Sucursal -->
                  <div
                    class="controlWrapper"
                    *ngIf="dealerBranches.length >= 1"
                  >
                    <label for=""
                      >Sucursal <span class="required">*</span></label
                    >
                    <div class="customSelect">
                      <select formControlName="wholeSaleId">
                        @if (dealerBranches.length === 0) {
                          <option [ngValue]="null">
                            {{
                              "El distribuidor no tiene sucursales habilitadas."
                            }}
                          </option>
                        } @else {
                          <option
                            *ngFor="let dealerBranch of dealerBranches"
                            [ngValue]="dealerBranch.id"
                          >
                            {{ dealerBranch.name }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                } @else if (dealerBranches.length === 0) {
                  <div class="controlWrapper">
                    <label>Sucursal</label>
                    <div class="customSelect">
                      <select [disabled]="true">
                        <option [ngValue]="null">
                          El distribuidor no tiene sucursales habilitadas.
                        </option>
                      </select>
                    </div>
                  </div>
                } @else {
                  <div id="financialService" class="controlWrapper">
                    <div class="conDistribuidorId">
                      <!-- Mostrar solo si se seleccionó Sucursal-->
                      <div>
                        <label>Sucursal</label
                        ><span class="value">
                          {{
                            dealerBranchName
                              ? dealerBranchName
                              : "No se encuentra sucursal"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                }

                <div class="controlWrapper nombre">
                  <label for=""
                    >Nombre de la cotización
                    <span class="required">*</span></label
                  >
                  <input name="" id="quoteName" formControlName="quoteName" />
                </div>
                <div class="controlWrapper" *ngIf="idQuote">
                  <label for="">Número</label>
                  <input type="number" [value]="idQuote" disabled />
                </div>
              </div>
            }
          </div>
          @if (!responsive.isMobileSignal()) {
            <app-client-desktop
              #clientDesktop
              formControlName="customer"
              [creationUser]="creationUser"
              [forceReadOnly]="linkedToCreditRequest || editOff"
              [hasDeals]="deals.length > 0"
              (requestOpenModal)="openRequestedModal()"
              [customerIdSaved]="formCustomerId"
              (selectedCustomerId)="setCustomerId($event)"
              (clearDeals)="confirmCompanyChangeClearDealsLocally()"
            ></app-client-desktop>
            <app-models-desktop
              [ready]="ready"
              (updateForm)="updateForm($event)"
              (setQuantity)="setQuantity($event)"
              (deleteAllDeals)="deleteAllDeals()"
            ></app-models-desktop>
          } @else {
            <app-client-mobile
              #clientMobile
              formControlName="customer"
              [creationUser]="creationUser"
              [forceReadOnly]="linkedToCreditRequest || editOff"
              [hasDeals]="deals.length > 0"
              (requestOpenModal)="openRequestedModal()"
              [customerIdSaved]="formCustomerId"
              (selectedCustomerId)="setCustomerId($event)"
              (clearDeals)="confirmCompanyChangeClearDealsLocally()"
            ></app-client-mobile>
            <app-models-mobile
              [ready]="ready"
              (updateForm)="updateForm($event)"
              (setQuantity)="setQuantity($event)"
              (deleteAllDeals)="deleteAllDeals()"
            ></app-models-mobile>
          }
        }
        <!-- <app-accessories
          [formArray]="form.get('accessories')"
          [accessories]="this.accessories"
          [creationUser]="creationUser"
          [idQuote]="idQuote"
        ></app-accessories> -->
        @if (!responsive.isMobileSignal()) {
          <app-deals-standard-quote-desktop
            (dealsUpdate)="updateDeal($event)"
            (setValueInService)="setValueInService(); isSetNullData = false"
            [deals]="form.controls['standardQuoteDeals'].value"
            [idQuote]="idQuote"
            [isValidForm]="isValidForm"
            [creationUser]="creationUser"
            [status]="form.controls['status'].value"
            [model]="form.controls['model'].value"
            [validBranch]="form.controls['wholeSaleId'].value === null"
          />
        } @else {
          <app-deals-standard-quote-mobile
            (dealsUpdate)="updateDeal($event)"
            (setValueInService)="setValueInService(); isSetNullData = false"
            [deals]="form.controls['standardQuoteDeals'].value"
            [idQuote]="idQuote"
            [isValidForm]="isValidForm"
            [creationUser]="creationUser"
            [status]="form.controls['status'].value"
            [model]="form.controls['model'].value"
            [validBranch]="form.controls['wholeSaleId'].value === null"
          />
        }
        <div class="quotationActions">
          @if (editOff || isInvalidQuote()) {
            <button type="button" (click)="cancel()" class="secondary">
              Volver
            </button>
            <button
              type="button"
              class="secondary"
              (click)="downloadPdf()"
              [disabled]="
                deals.length == 0 ||
                !isSelectedDeal ||
                !isValidForm ||
                form.controls['wholeSaleId'].value === null
              "
            >
              Descargar PDF
            </button>
            @if (showExtendValidityBanner()) {
              <button
                type="button"
                class="secondary"
                (click)="openExtendValidityConfirmModal()"
                [disabled]="extendingValidity"
              >
                {{ extendingValidity ? "Extendiendo…" : "Extender vigencia" }}
              </button>
            }
          } @else if (customerOnlyEditMode) {
            <button type="button" (click)="cancel()" class="secondary">
              {{
                creationUser == null ||
                creationUser == authService.currentUserIds
                  ? "Cancelar"
                  : "Volver"
              }}
            </button>
            <button
              type="button"
              class="secondary"
              (click)="downloadPdf()"
              [disabled]="
                deals.length == 0 ||
                !isSelectedDeal ||
                !isValidForm ||
                form.controls['wholeSaleId'].value === null
              "
            >
              Descargar PDF
            </button>
            @if (showExtendValidityBanner()) {
              <button
                type="button"
                class="secondary"
                (click)="openExtendValidityConfirmModal()"
                [disabled]="extendingValidity"
              >
                {{ extendingValidity ? "Extendiendo…" : "Extender vigencia" }}
              </button>
            }
            <button
              type="button"
              class="primary"
              (click)="update()"
              [disabled]="!isCustomerSectionValid"
            >
              Guardar
            </button>
          } @else {
            <button type="button" (click)="cancel()" class="secondary">
              {{
                creationUser == null ||
                creationUser == authService.currentUserIds
                  ? "Cancelar"
                  : "Volver"
              }}
            </button>
            <button
              type="button"
              class="secondary"
              (click)="update(true)"
              [disabled]="deals.length == 0 || !isSelectedDeal || !isValidForm"
            >
              Descargar PDF
            </button>
            @if (showExtendValidityBanner()) {
              <button
                type="button"
                class="secondary"
                (click)="openExtendValidityConfirmModal()"
                [disabled]="extendingValidity"
              >
                {{ extendingValidity ? "Extendiendo…" : "Extender vigencia" }}
              </button>
            }
            <button
              type="submit"
              class="primary"
              [disabled]="
                !saved ||
                !isValidForm ||
                form.controls['wholeSaleId'].value === null
              "
              *ngIf="
                creationUser == null ||
                creationUser == authService.currentUserIds
              "
            >
              Guardar
            </button>
          }
        </div>
      </form>
    </div>
  </div>
</main>
<ng-template #extendValidityModalTemplate>
  <div class="modal" style="max-width: 620px">
    <a class="close" (click)="closeExtendValidityConfirmModal()">Cerrar</a>
    <h1>Extender vigencia</h1>
    <p>
      Cotización vencida. ¿Seguro que desea extender la vigencia de esta
      cotización por
      {{ quoteValidityInfo?.minQuoteValidityDays }} días?
    </p>
    <div class="modalActions index">
      <button
        type="button"
        (click)="closeExtendValidityConfirmModal()"
        class="secondary"
      >
        Cancelar
      </button>
      <button
        type="button"
        (click)="confirmExtendValidityFromModal()"
        class="primary"
        [disabled]="extendingValidity"
      >
        Confirmar
      </button>
    </div>
  </div>
</ng-template>
<ng-template #modalTemplate>
  <div class="modal" style="max-width: 620px">
    <a class="close" (click)="cancelChanges()">Cerrar</a>
    <h1>Eliminar propuestas</h1>
    <p>
      Está editando datos sensibles, si continúa con los cambios todas las
      propuestas generadas anteriormente serán eliminadas.
    </p>
    <div class="modalActions index">
      <button (click)="cancelChanges()" class="secondary">Cancelar</button>
      <button (click)="confirmCompanyChangeClearDealsLocally()" class="primary">
        Eliminar
      </button>
    </div>
  </div>
</ng-template>
